export default __webpack_public_path__ + "static/media/image.2b7ef8de.svg";